module.exports = __webpack_public_path__ + "static/img/book11.5dbba74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book11.jpg
// module id = XPWc
// module chunks = 1